import { type MCPServerInfo } from '../../types';

const GoogleCalendarServer: MCPServerInfo = {
  serverId: 'GOOGLE_CALENDAR',
  name: 'Google Calendar',
  slug: 'google-calendar',
  description:
    'Google Calendar MCP Server for listing calendars, managing events, and finding free time slots',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/google-mcp-servers',
    commitSha: 'd77ea24',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GoogleCalendarServer;
